angular.module('mercury.modules.reports.staff')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Reports.StaffOverview', {
    url: '/staff?report',
    templateUrl: 'modules/reports/staff/overview.tpl.html',
    controller: 'ReportsStaffOverviewCtrl'
  });

  $stateProvider.state('Reports.StaffOrders', {
    url: '/staff/orders?report',
    templateUrl: 'modules/reports/staff/orders.tpl.html',
    controller: 'ReportsStaffOrdersCtrl'
  });

  $stateProvider.state('Reports.StaffOrdersDetails', {
    url: '/staff/ordersdetails?report&staffId&staffName',
    templateUrl: 'modules/reports/revenue/orders.tpl.html',
    controller: 'ReportsRevenueOrdersCtrl',
    data: {
      menuLinkState: 'Reports.StaffOrders'
    }
  });

  $stateProvider.state('Reports.StaffSales', {
    url: '/staff/sales?report',
    templateUrl: 'modules/reports/staff/sales.tpl.html',
    controller: 'ReportsStaffSalesCtrl'
  });

  $stateProvider.state('Reports.StaffSalesDetails', {
    url: '/staff/salesdetails?report&staffId&staffName',
    templateUrl: 'modules/reports/revenue/invoices.tpl.html',
    controller: 'ReportsRevenueInvoicesCtrl',
    data: {
      menuLinkState: 'Reports.StaffSales'
    }
  });

  $stateProvider.state('Reports.StaffItems', {
    url: '/staff/items?report',
    templateUrl: 'modules/reports/staff/items.tpl.html',
    controller: 'ReportsStaffItemsCtrl'
  });

  $stateProvider.state('Reports.StaffItemsDetails', {
    url: '/staff/itemsdetails?report&staffId&staffName',
    templateUrl: 'modules/reports/items/products.tpl.html',
    controller: 'ReportsItemsProductsCtrl',
    data: {
      menuLinkState: 'Reports.StaffItems'
    }
  });

  $stateProvider.state('Reports.StaffCost', {
    url: '/staff/cost?report',
    templateUrl: 'modules/reports/staff/staffcost.tpl.html',
    controller: 'ReportsStaffCostCtrl'
  });

  $stateProvider.state('Reports.StaffItemGroups', {
    url: '/staff/itemgroups?report',
    templateUrl: 'modules/reports/staff/itemgroups.tpl.html',
    controller: 'ReportsStaffItemGroupsCtrl'
  });

  $stateProvider.state('Reports.StaffItemGroupsDetails', {
    url: '/staff/itemgroupsdetails?report&staffId&staffName',
    templateUrl: 'modules/reports/items/itemgroups.tpl.html',
    controller: 'ReportsItemGroupsCtrl',
    data: {
      menuLinkState: 'Reports.StaffItemGroups'
    }
  });

  $stateProvider.state('Reports.StaffDiscounts', {
    url: '/staff/discounts?report',
    templateUrl: 'modules/reports/staff/discounts.tpl.html',
    controller: 'ReportsStaffDiscountsCtrl'
  });

  $stateProvider.state('Reports.StaffDiscountsDetails', {
    url: '/staff/discountsdetails?report&staffId&staffName',
    templateUrl: 'modules/reports/discounts/types.tpl.html',
    controller: 'ReportsDiscountTypesCtrl',
    data: {
      menuLinkState: 'Reports.StaffDiscounts'
    }
  });

  $stateProvider.state('Reports.StaffSurcharges', {
    url: '/staff/surcharges?report',
    templateUrl: 'modules/reports/staff/surcharges.tpl.html',
    controller: 'ReportsStaffSurchargesCtrl'
  });

  $stateProvider.state('Reports.StaffSurchargesDetails', {
    url: '/staff/surchargesdetails?report&staffId&staffName',
    templateUrl: 'modules/reports/discounts/surchargeTypes.tpl.html',
    controller: 'ReportsSurchargeTypesCtrl',
    data: {
      menuLinkState: 'Reports.StaffSurcharges'
    }
  });

  $stateProvider.state('Reports.StaffVoids', {
    url: '/staff/voids?report',
    templateUrl: 'modules/reports/staff/voids.tpl.html',
    controller: 'ReportsStaffVoidsCtrl'
  });

  $stateProvider.state('Reports.StaffVoidsDetails', {
    url: '/staff/voidsdetails?report&staffId&staffName',
    templateUrl: 'modules/reports/voids/reasons.tpl.html',
    controller: 'ReportsVoidReasonsCtrl',
    data: {
      menuLinkState: 'Reports.StaffSales'
    }
  });
  $stateProvider.state('Reports.StaffTables', {
    url: '/staff/tables?report',
    templateUrl: 'modules/reports/staff/tables.tpl.html',
    controller: 'ReportsStaffTablesCtrl'
  });
  $stateProvider.state('Reports.StaffTablesDetails', {
    url: '/staff/tablesdetails?report&staffId&staffName',
    templateUrl: 'modules/reports/revenue/tables.tpl.html',
    controller: 'ReportsRevenueTablesCtrl',
    data: {
      menuLinkState: 'Reports.StaffTables'
    }
  });
}]);
